export default __webpack_public_path__ + "static/media/preview-mixed-media.2c55e4f6.jpg";